import React from "react";
import { Link } from "react-router-dom";
import { IClub } from "@eagerdog/interfaces";

import { helperService } from "src/services/helper.service";

import Icon from "src/components/Icon/Icon";

import styles from "./ClubCard.module.scss";

interface IProps {
    club: IClub,
    isFavorite?: boolean,
    onToggleFavorite(id: string): void
}

const ClubCard: React.FC<IProps> = (props: IProps) => {
    return (
        <div className={props.isFavorite ? `${styles.ClubCard} ${styles.isFavorite}` : `${styles.ClubCard}`}>
        <div className={styles.coverImage} style={props.club.cover_image_url ? { backgroundImage: "url("+ props.club.cover_image_url +")" } : {}}>
            {helperService.isLoggedIn() && <div className={styles.favWrap}>
                <div className={styles.favIcon} onClick={() => { props.onToggleFavorite(props.club._id) }}>
                    <Icon className={styles.favIconClick} type={props.isFavorite ? "heartFilled" : "heart"} />
                </div>
            </div>}
        </div>
        <div className={styles.inner}>
            <div className={styles.logo}>
                {props.club.logo_url && <img alt={props.club.club_name + " Profile"} src={props.club.logo_url} loading="lazy" />}
                {!props.club.logo_url && <div className={styles.initial}>{props.club.club_name.substring(0, 1)}</div>}
            </div>
            <div className={styles.content}>
                <div className={styles.clubName}>{props.club.club_name}</div>
                <div className={styles.address}>{helperService.formatAddress(props.club.address)}</div>
                <div className={styles.actions}>
                    <Link to={"/k/" + props.club._id}>View Club</Link>
                </div>
            </div>
        </div>
        </div>
    );
};

export default ClubCard;